import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { noop } from 'rxjs';
import { ArticlesService } from 'src/app/services/articles.service';
import { AuthProvider } from 'src/app/services/auth.provider';
import { ConfigService } from 'src/app/services/config.service';
import { Multitenant } from 'src/app/services/multitenant.provider';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.html',
  styleUrls: ['./filter.scss']
})
export class FilterComponent {
    public isFilterVisible = false;
    public date: string;
    public selectedFilterJournal = '';
    public selectedFilterCategory = '';
    public filterCategories: { category_name: string, category_slug: string }[] = [{ category_name: 'Choisir une catégorie', category_slug: '' }];
    public maxDate = (new Date()).toISOString();

    constructor(
        private router: Router,
        private articlesService: ArticlesService,
        public tenantService: Multitenant,
        public auth: AuthProvider,
        public configService: ConfigService
    ) { }

    public get subscriptions() {
        return this.auth.isAuthenticated() ? this.auth.getAccessNewspapers() : [];
    }

    public onCloseFilter() {
        this.filterCategories = [{ category_name: 'Choisir une catégorie', category_slug: '' }],
        this.selectedFilterJournal = '';
        this.selectedFilterCategory = '';
        this.isFilterVisible = false;
        this.date = null;
    }

    public onApplyFilter() {
        if (this.selectedFilterJournal.length || (this.selectedFilterCategory.length && this.date)) {

            const queryParams = { queryParams: { filter: this.selectedFilterJournal, category:  this.selectedFilterCategory, date: this.date ?this.date.slice(0, 10): null } };
            this.router.navigate(['/'], queryParams);
            this.selectedFilterJournal = '';
            this.selectedFilterCategory = '';
            this.isFilterVisible = false;
            this.date = null;
        }
    }

    public onJournalChange(event: any)  {
        this.articlesService.getJournalCategories(event.target.value).subscribe({
            next:(data: any) => this.filterCategories = [{ category_name: 'Choisir une catégorie', category_slug: '' }, ...data[event.target.value]],
            error:() => noop
        });
    }
}
